import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

 
let duration = 400;

const I1 = "https://www.winpeforum.com/assets/sheshines/2july2026/1.jpg";
const I2 = "https://www.winpeforum.com/assets/sheshines/2july2026/2.jpg";
const I3 = "https://www.winpeforum.com/assets/sheshines/2july2026/3.jpg";
const I4 = "https://www.winpeforum.com/assets/sheshines/2july2026/4.jpg";
const I5 = "https://www.winpeforum.com/assets/sheshines/2july2026/5.jpg";
const I6 = "https://www.winpeforum.com/assets/sheshines/2july2026/6.jpg";
const I7 = "https://www.winpeforum.com/assets/sheshines/2july2026/7.jpg";
const I8 = "https://www.winpeforum.com/assets/sheshines/2july2026/8.jpg";
const I9 = "https://www.winpeforum.com/assets/sheshines/2july2026/9.jpg";
const I10 = "https://www.winpeforum.com/assets/sheshines/2july2026/10.jpg";
const I11 = "https://www.winpeforum.com/assets/sheshines/2july2026/11.jpg";
const I12 = "https://www.winpeforum.com/assets/sheshines/2july2026/12.jpg";
const I13 = "https://www.winpeforum.com/assets/sheshines/2july2026/13.jpg";
const I14 = "https://www.winpeforum.com/assets/sheshines/2july2026/14.jpg";
const I15 = "https://www.winpeforum.com/assets/sheshines/2july2026/15.jpg";
const I16 = "https://www.winpeforum.com/assets/sheshines/2july2026/16.jpg";
const I17 = "https://www.winpeforum.com/assets/sheshines/2july2026/17.jpg";
const I18 = "https://www.winpeforum.com/assets/sheshines/2july2026/18.jpg";
const I19 = "https://www.winpeforum.com/assets/sheshines/2july2026/19.jpg";
const I20 = "https://www.winpeforum.com/assets/sheshines/2july2026/20.jpg";
const I21 = "https://www.winpeforum.com/assets/sheshines/2july2026/21.jpg";
const I22 = "https://www.winpeforum.com/assets/sheshines/2july2026/22.jpg";
const I23 = "https://www.winpeforum.com/assets/sheshines/2july2026/23.jpg";
const I24 = "https://www.winpeforum.com/assets/sheshines/2july2026/24.jpg";
const I25 = "https://www.winpeforum.com/assets/sheshines/2july2026/25.jpg";
const I26 = "https://www.winpeforum.com/assets/sheshines/2july2026/26.jpg";
const I27 = "https://www.winpeforum.com/assets/sheshines/2july202627.jpg";



const II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/1.jpg";
const II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/2.jpg";
const II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/3.jpg";
const II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/4.jpg";
const II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/5.jpg";
const II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/6.jpg";
const II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/7.jpg";
const II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/8.jpg";
const II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/9.jpg";
const II10 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/10.jpg";
const II11 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/11.jpg";
const II12 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/12.jpg";
const II13 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/13.jpg";
const II14 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/14.jpg";
const II15 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/15.jpg";
const II16 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/16.jpg";
const II17 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/17.jpg";
const II18 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/18.jpg";
const II19 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/19.jpg";
const II20 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/20.jpg";
const II21 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/21.jpg";
const II22 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/22.jpg";
const II23 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/23.jpg";
const II24 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/24.jpg";
const II25 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/25.jpg";
const II26 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/26.jpg";
const II27 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/27.jpg";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
   
  
 
    this.CollegiumsImages = [
      { id:1, ImgSrc: I1, ImgSrc1: II1,},
        { id:1, ImgSrc: I2, ImgSrc1: II2,},
        { id:2, ImgSrc: I3, ImgSrc1: II3,},
        { id:3, ImgSrc: I4, ImgSrc1: II4,},
        { id:4, ImgSrc: I5, ImgSrc1: II5,},
        { id:5, ImgSrc: I6, ImgSrc1: II6,},
        { id:6, ImgSrc: I7, ImgSrc1: II7,},
        { id:7, ImgSrc: I8, ImgSrc1: II8,},
        { id:8, ImgSrc: I9, ImgSrc1: II9,},
        { id:9, ImgSrc: I10, ImgSrc1: II10,},
        { id:10, ImgSrc: I11, ImgSrc1: II11,},
        { id:11, ImgSrc: I12, ImgSrc1: II12,},
        { id:12, ImgSrc: I13, ImgSrc1: II13,},
        { id:13, ImgSrc: I14, ImgSrc1: II14,},
        { id:13, ImgSrc: I15, ImgSrc1: II15,},
        { id:13, ImgSrc: I16, ImgSrc1: II16,},
        { id:13, ImgSrc: I17, ImgSrc1: II17,},
        { id:13, ImgSrc: I18, ImgSrc1: II18,},
        { id:18, ImgSrc: I19, ImgSrc1: II19,},
        { id:19, ImgSrc: I20, ImgSrc1: II20,},
        { id:20, ImgSrc: I21, ImgSrc1: II21,},
        { id:21, ImgSrc: I22, ImgSrc1: II22,},
        { id:22, ImgSrc: I23, ImgSrc1: II23,},
        { id:23, ImgSrc: I24, ImgSrc1: II24,},
        { id:24, ImgSrc: I25, ImgSrc1: II25,},
        { id:25, ImgSrc: I26, ImgSrc1: II26,},
        { id:26, ImgSrc: I27, ImgSrc1: II27,},
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="sheshines with Winpe"
          image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
          description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
               
              <div className="container">
                    <div>
                      <Heading title="sheshines with Winpe Image Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'330px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
<br/><br/>
               
                 
                      
                    

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/sheshines2July2026/gallery.js